<!-- 数据交易所 -->
<template>
  <div>
    <div class="content-content">
      <div class="search-content">
        <el-form ref="form" :model="queryFrom" label-width="150px">
          <el-form-item label="地区数据交易所选择:">
            <el-row>
              <el-col :span="8">
                <GsRegionSelect placeholder="请选择数据服务区域" @change="changeSelect" />
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
      </div>
      <div v-loading="loading">
        <el-table
          :data="tableData"
          border
          style="width: 100%"
          class="table-content"
        >
          <el-table-column
            prop="dataTradingFull"
            label="数据交易所名称"
            header-align="center"
            align="left"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            prop="tradingCenterIntroduction"
            label="交易所介绍"
            header-align="center"
            align="left"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            prop="dataTradingWeb"
            label="官网地址"
            header-align="center"
            align="center"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            prop="phone"
            label="电话"
            header-align="center"
            align="center"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            prop="email"
            label="邮箱"
            header-align="center"
            align="center"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            prop="officeAddress"
            label="办公地址"
            header-align="center"
            align="center"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="操作"
            width="120"
            align="center"
          >
            <template #default="scope">
              <el-button
                @click.prevent="detailRow(scope.row)"
                type="text"
                size="small"
              >
                详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="table-pagination">
          <GsPagination
            :current-page="currentPage"
            :page-size="pageSize"
            :total="total"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
    <div>
      <el-dialog
        title="数据交易所详情"
        v-model="dialogVisible"
        width="80%"
      >
        <DataTradingInfo
          :tradingId="tradingId"
          :readOnly="true"
        />
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import DataTradingInfo from '@/views/Home/components/dataInfo/DataTradingInfo.vue'
import { dataTradingList } from '@/api/Home/index.js'
import GsPagination from '@/components/GsPagination/index.vue'
import GsRegionSelect from '@/components/GsRegionSelect/index.vue'
export default {
  name: 'DataTradingInfoList',
  components: {
    DataTradingInfo,
    GsPagination,
    GsRegionSelect
  },
  data() {
    return {
      title: (this.$route.meta && this.$route.meta.title) || '',
      loading: false,
      tradingId: '',
      input2: '',
      queryFrom: {
        currentPage: 1,
        pageSize: 20,
        administrativeDivisionCode: '',
        whetherPublish: '1'
      },
      dialogVisible: false,
      areaList: [],
      tableData:[],
      dialogTitle: '',
      total: 0,
      currentPage: 1,
      pageSize: 20
    }
  },
  watch:{
  },
  created() {
    this.initData(this.queryFrom)
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val
      this.queryFrom.pageSize = val
      this.initData(this.queryFrom)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.queryFrom.currentPage = val
      this.initData(this.queryFrom)
    },
    clickBtn() {
      this.initData(this.queryFrom)
    },
    changeSelect(data) {
      if(data && data.length > 0) {
        this.queryFrom.administrativeDivisionCode = JSON.stringify(data)
      } else {
        this.queryFrom.administrativeDivisionCode = ''
      }
      this.initData(this.queryFrom)
    },
    // 列表数据
    initData(data) {
      this.loading = true
      dataTradingList(data).then(res => {
        this.loading = false
        this.tableData = res.rows
        this.total = res.total
      }).catch(()=>{
        this.loading = false
      })
    },
    detailRow(row) {
      this.tradingId = row.id
      this.$nextTick(()=>{
        this.dialogVisible = true
      })
    },
    closeDetailDialog(data) {
      this.dialogVisible = data
    }
  }
}
</script>
<style lang="css" scoped>
.search-content{
  padding: 20px;
}
.search-search {
  text-align: center;
}
::v-deep .form-label .el-form-item__content {
  display: flex !important;
  flex-wrap: wrap;
}
@media (max-width: 960px) {
  .search-content {
    padding: 12px 8px;
  }
  .search-content :deep(.el-col) {
    max-width: 100% !important;
    flex: 0 0 100% !important;
  }
  .search-content :deep(.el-form-item) {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    margin-bottom: 10px;
  }
  .search-content :deep(.el-form-item__label) {
    width: auto !important;
    text-align: left !important;
    line-height: 1.35 !important;
    height: auto !important;
    padding: 0 0 2px !important;
    font-size: 12px !important;
  }
  .search-content :deep(.el-form-item__content) {
    margin-left: 0 !important;
    font-size: 13px !important;
  }
}
</style>